import { BaseContext } from '../../../../utils/basecontext';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import { POST } from '../../api';
import { SixdeeCRBTAPI } from '../../sixdeecrbtapi';
import { GiftToneRequest } from './gifttonerequest';
import { LanguageConst } from 'src/com/sixdee/crbtportal/utils/resources/languageconst';

export class GiftToneAPI extends SixdeeCRBTAPI<GiftToneRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return POST;
    }

    getAPIURL(): string
    {
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/send-gift
        return "send-gift";
    }

    getRequestData()
    {
        return "msisdnA="+ this.getRequest().getGiftToneRequest().getMsisdnA()+"&"+
               "msisdnB="+ this.getRequest().getGiftToneRequest().getMsisdnB()+"&"+
               "toneId="+ this.getRequest().getGiftToneRequest().getToneId()+"&"+
               "channel="+ this.getRequest().getGiftToneRequest().getChannelId()+"&"+
               "username="+ this.getRequest().getGiftToneRequest().getUserName()+"&"+
               "language="+ (this.getRequest().getGiftToneRequest().getLanguage() === LanguageConst.ENGLISH ? "1": "2")+"&"+
               "packName="+ this.getRequest().getGiftToneRequest(). getPackName()+"&"+
               "toneName="+ this.getRequest().getGiftToneRequest().getToneName();
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/tune/gifttune/gifttoneapi.tsx